import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string
  color?: string
  size?: number | string
  rotateOnRtl?: boolean
}
export const IconPerson: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 12 13',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.33301 8C10.7997 8 12 9.20033 12 10.667V11.333C12 12.0662 11.4002 12.6668 10.667 12.667H1.33301C0.599822 12.6668 0 12.0662 0 11.333V10.667C0 9.20033 1.20033 8 2.66699 8H9.33301ZM6 0C7.86656 6.24406e-08 9.33284 1.4665 9.33301 3.33301C9.33301 5.19967 7.86667 6.66699 6 6.66699C4.13333 6.66699 2.66699 5.19967 2.66699 3.33301C2.66716 1.4665 4.13344 0 6 0Z',
    })
  )
}
